import InstanceFactory from "../src/factories/InstanceFactory";
import Assets from "./utils/Assets";
import Utils from "./utils/Utils";
import Locale from "./utils/Locale";
import { ILayoutSettings } from "./baseConfigs/layoutConfigShema";
import { TimelineMax, TimelineLite, TweenMax } from "gsap";
import ParticleLoop from "./utils/ParticleLoop";
import IAppGameConfig from './model/IAppGameConfig';
import GameModel from "./model/GameModel";
import ConsoleUtil from './utils/ConsoleUtil';


export default class App extends PIXI.Application {

    // TODO EXTRACT THOSE FROM HERE
    static version: string;
    // static layout;
    // static config: IAppGameConfig;
    static renderer: PIXI.CanvasRenderer | PIXI.WebGLRenderer;
    static assets: Assets;
    static utils: Utils;
    static gameFactory;
    static dispatcher: PIXI.utils.EventEmitter;
    static locale;

    static instance: App;
    static width: number;
    static height: number;
    static timeline: TimelineMax;

    constructor(settingsConfig: ILayoutSettings, options?: PIXI.ApplicationOptions) {
        if (App.instance) {
            return App.instance;
        }

        const START_WIDTH = settingsConfig.nativeWidth;
        const START_HEIGHT = settingsConfig.nativeHeight;
        App.width = START_WIDTH;
        App.height = START_HEIGHT;
        const vpWidth = window.innerWidth;
        const vpHeight = window.innerHeight;
        let maxDPI = 2;
        if (vpWidth > START_WIDTH || vpHeight > START_HEIGHT ) {
            maxDPI = 1;
        }

        let dpr = Math.min(window.devicePixelRatio || 1 , maxDPI);
        // const dpr = window.devicePixelRatio || 1;
        // const dpr = 1;
        const lowRes = window.screen.width * window.screen.height * dpr <= 1280 * 720;
        
        ConsoleUtil.log("[App] Setup stage");

        // Set width and height to 10 to force resize - fix for Samsung browser
        super({width: 10, height: 10, transparent: true, resolution: dpr, roundPixels: lowRes });
        
        //     this.dispatcher = new PIXI.utils.EventEmitter();
        App.instance = this;
        PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.LINEAR;
        // }
        App.locale = Locale;
        App.gameFactory = InstanceFactory;
        App.timeline = new TimelineMax({
            autoRemoveChildren: true,
            smoothChildTiming: true
        });

        App.instance.ticker.add((time) => {
            App.gameLoopFunction(time);
        });
        // App.layout = Layout;
    }

    static get config(): IAppGameConfig {
        return GameModel.gameConfig;
    }

    static set config(cg: IAppGameConfig) {
        console.warn("REMOVE CONFIG SETTING FROM INDEX.TS");
    }

    private static gameLoopFunction(time: number) {
        //TODO all game updates should happen here
        if (!App.timeline.isActive() && App.timeline.getChildren().length ) {
            // FIX FOR GLOBAL TIMELINE DISRUPTION
            console.warn("[TIMELINE STATUS DISRUPTED]:", App.timeline.paused(), App.timeline.isActive(), App.timeline.getChildren());
            App.timeline.play();
        }
        ParticleLoop.update(time);
    }

/**
 *
 * @param display {PIXI.DisplayObject}
 * @param callback {Function}
 * @param args {*[]=}
 * @param context {*=}
 */
    static addedToStage(display, callback, args = null, context = null) {
        while (display.parent) {
            display = display.parent;
        }
        if (display === App.instance.stage) {
            callback.apply(context, args);
        } else {
            display.once(
                "added",
                () => {
                    App.addedToStage(display, callback, args, context);
                },
                this
            );
        }
    }


}

